(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4004],{

/***/ 43832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),

/***/ 22318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(align))], display !== 'initial' && classes["display".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(display))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiTypography'
})(Typography));

/***/ }),

/***/ 1438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ useIsDesktop; },
/* harmony export */   "Hi": function() { return /* binding */ Desktop; },
/* harmony export */   "Y9": function() { return /* binding */ LargeScreen; },
/* harmony export */   "_": function() { return /* binding */ MediumScreen; },
/* harmony export */   "ij": function() { return /* binding */ Mobile; }
/* harmony export */ });
/* unused harmony exports useCustomQuery, IEMediaQuery, EdgeMediaQuery */
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53450);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63457);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useCustomQuery = function useCustomQuery(minWidth) {
  return _useMediaQuery("(min-width:".concat(minWidth, "px)"));
};
var useIsDesktop = function useIsDesktop() {
  return (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (theme) {
    return theme.breakpoints.up("md");
  });
};
var Mobile = function Mobile(_ref) {
  var children = _ref.children,
      _ref$aboveTheFold = _ref.aboveTheFold,
      aboveTheFold = _ref$aboveTheFold === void 0 ? false : _ref$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    mdUp: true,
    children: children
  });
};
var Desktop = function Desktop(_ref2) {
  var children = _ref2.children,
      _ref2$aboveTheFold = _ref2.aboveTheFold,
      aboveTheFold = _ref2$aboveTheFold === void 0 ? false : _ref2$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    smDown: true,
    children: children
  });
};
var MediumScreen = function MediumScreen(_ref3) {
  var children = _ref3.children,
      _ref3$aboveTheFold = _ref3.aboveTheFold,
      aboveTheFold = _ref3$aboveTheFold === void 0 ? false : _ref3$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    only: ["xs", "sm", "xl"],
    children: children
  });
};
var LargeScreen = function LargeScreen(_ref4) {
  var children = _ref4.children,
      _ref4$aboveTheFold = _ref4.aboveTheFold,
      aboveTheFold = _ref4$aboveTheFold === void 0 ? false : _ref4$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    lgDown: true,
    children: children
  });
};
var IEMediaQuery = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)";
var EdgeMediaQuery = "@supports (-ms-ime-align:auto)";

/***/ }),

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 78980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92208);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);
/* harmony import */ var _CreateAiContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90374);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var StyledBottomNavigation = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CreatePictureAiButton__StyledBottomNavigation",
  componentId: "sc-7pn3bq-0"
})(["height:70px;padding:10px;justify-content:center;background-color:", ";border-top-left-radius:10px;border-top-right-radius:10px;box-shadow:0 5px 15px 0 rgba(0,0,0,0.04);position:fixed;bottom:0;width:100%;z-index:1;right:0;", "{position:relative;width:300px;background-color:none;box-shadow:none;}"], function (p) {
  return p.theme.colors.white;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
});

var CreatePictureAiButton = function CreatePictureAiButton(_ref2) {
  var text = _ref2.text,
      enabledButton = _ref2.enabledButton,
      submit = _ref2.submit;

  var _useCreateAiContext = (0,_CreateAiContext__WEBPACK_IMPORTED_MODULE_1__/* .useCreateAiContext */ .uh)(),
      stylesData = _useCreateAiContext.stylesData,
      propertiesData = _useCreateAiContext.propertiesData,
      backgroundsData = _useCreateAiContext.backgroundsData;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBottomNavigation, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      btnType: "filled",
      disabled: !enabledButton ? !(stylesData && propertiesData.length > 0 && backgroundsData) : false,
      onClick: function onClick() {
        submit();
      },
      children: text
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CreatePictureAiButton);

/***/ }),

/***/ 92208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(282);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var StyledButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "GenericButton__StyledButtonContainer",
  componentId: "sc-r0056q-0"
})(["width:", ";", " ", " height:48px;", "{width:", ";", "}display:flex;justify-content:center;align-items:center;border-radius:8px;padding:8px 16px;font-family:NarkisBlock;font-size:24px;color:var(--Black,var(--Primary-Black,#000));cursor:pointer;", " ", " ", " ", ""], function (p) {
  return p !== null && p !== void 0 && p.$width ? "".concat(p === null || p === void 0 ? void 0 : p.$width, "px") : "328px";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$width) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$fullWidth) && "width: 100%;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p !== null && p !== void 0 && p.$mobileWidth ? "".concat(p === null || p === void 0 ? void 0 : p.$mobileWidth, "px") : "100%";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "filled" && !(p !== null && p !== void 0 && p.$disabled) && "\n      background: var(--Yellow, #ffbc0d);\n\n      &:hover {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n        background: var(--Yellow, #ffbc0d);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: #F5B511;\n      }\n    ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "outlined" && !(p !== null && p !== void 0 && p.$disabled) && "\n      border: 2px solid var(--Yellow, #FFBC0D);\n      background: var(--White, #FFF);\n\n\n      &:hover {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n        background: var(--White, #FFF);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: rgba(247, 247, 247, 0.50);\n      }\n  ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$disabled) && "\n      background: var(--Light-Grey, #F7F7F7);\n      color: rgba(45, 45, 45, 0.72);\n    ";
}, function (p) {
  return p.isdisabled && "\n    background: var(--Light-Grey, #f7f7f7);\n    color: rgba(45, 45, 45, 0.72);\n    font-size: 24px;\n    :hover {\n    background: var(--Light-Grey, #f7f7f7);\n\n  }\n  ";
});
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "GenericButton__StyledIcon",
  componentId: "sc-r0056q-1"
})([""]);

var GenericButton = function GenericButton(_ref) {
  var btnType = _ref.btnType,
      width = _ref.width,
      mobileWidth = _ref.mobileWidth,
      icon = _ref.icon,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      buttonHref = _ref.buttonHref,
      isdisabled = _ref.isdisabled;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButtonContainer, {
    $width: width,
    $mobileWidth: mobileWidth,
    $btnType: btnType,
    $disabled: disabled,
    $fullWidth: fullWidth,
    onClick: onClick,
    disabled: disabled,
    type: type,
    isdisabled: isdisabled,
    className: className,
    href: buttonHref,
    children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: icon
    }), children, endIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: endIcon
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GenericButton);

/***/ }),

/***/ 26490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SingleButtonSelection__StyledContainer",
  componentId: "sc-1586vsq-0"
})(["display:flex;flex-wrap:wrap;"]);
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "SingleButtonSelection__StyledButtonWrap",
  componentId: "sc-1586vsq-1"
})(["width:", ";"], function (props) {
  return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "SingleButtonSelection__StyledLabel",
  componentId: "sc-1586vsq-2"
})(["width:100%;height:44px;border:solid 1px transparent;position:relative;display:flex;align-items:center;justify-content:center;border-radius:5px;background-color:#fff;font-size:16px;direction:", ";cursor:pointer;position:relative;", " @media print{display:none;justify-content:flex-start;box-shadow:none;background-image:none !important;span{justify-content:flex-start;}}b{font-size:1.5em;}span{width:100%;height:100%;display:flex;align-items:center;justify-content:center;position:absolute;inset:0;line-height:1;}", ""], function (p) {
  return p.$isBattery ? "ltr" : "rtl";
}, function (p) {
  return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function (p) {
  return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "SingleButtonSelection__StyledRadio",
  componentId: "sc-1586vsq-3"
})(["position:absolute;border:0;margin:-1px;padding:0;border-radius:50%;width:1px;height:1px;opacity:0;:checked + ", "{border-color:", ";color:", ";background-image:url(\"/battery-button.svg\");@media print{display:block;border:none;}}:focus + ", "{border-color:", ";color:", ";background-image:url(\"/battery-button.svg\");@media print{display:block;border:none;}}:hover{border:2px solid black;}:focus-visible{border:3px solid ", " !important;}"], StyledLabel, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, StyledLabel, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (p) {
  return p.theme.colors.darkYellow;
});
var SingleButtonSelection = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref5, bgRef) {
  var id = _ref5.id,
      items = _ref5.items,
      onSelect = _ref5.onSelect,
      isBattery = _ref5.isBattery,
      customButton = _ref5.customButton,
      selectedValue = _ref5.selectedValue,
      className = _ref5.className,
      _ref5$itemsPerRow = _ref5.itemsPerRow,
      itemsPerRow = _ref5$itemsPerRow === void 0 ? 2 : _ref5$itemsPerRow,
      _ref5$gap = _ref5.gap,
      gap = _ref5$gap === void 0 ? 10 : _ref5$gap,
      _ref5$allowEmpty = _ref5.allowEmpty,
      allowEmpty = _ref5$allowEmpty === void 0 ? false : _ref5$allowEmpty,
      _ref5$noFocus = _ref5.noFocus,
      noFocus = _ref5$noFocus === void 0 ? false : _ref5$noFocus;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(allowEmpty ? selectedValue : selectedValue || items[0].value),
      selectedButton = _useState[0],
      setSelectedButton = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!items || !items.length || !selectedValue) {
      return;
    }

    setSelectedButton(selectedValue || items[0].value);
  }, [items, selectedValue]);

  var handleChange = function handleChange(value, index) {
    setSelectedButton(value);
    onSelect(value, index);
  };

  return (
    /*#__PURE__*/
    // <RowWithTitle {...{ title, id, headlineComponent }} noPrint={!isBattery}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
      role: "radiogroup",
      "aria-labelledby": id,
      $gap: gap,
      className: className,
      children: items.map(function (item, index) {
        var _item$name;

        var radioId = "radio_".concat(id, "_").concat(item.value);
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
          tabIndex: noFocus ? -1 : undefined,
          role: "presentation",
          $itemsPerRow: itemsPerRow,
          $gap: gap,
          "aria-label": item !== null && item !== void 0 && item.ariaLabel ? item === null || item === void 0 ? void 0 : item.ariaLabel : index === 0 ? "".concat(item.name, " \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D4\u05DE\u05EA\u05E0\u05D4, \u05E0\u05D5\u05D5\u05D8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D7\u05E6\u05D9\u05DD") : item.name,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter") {
              handleChange(item.value, index);
              setSelectedButton(item.value);
            }
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
            "aria-label": index === 0 ? "".concat(item.name, " \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D4\u05DE\u05EA\u05E0\u05D4, \u05E0\u05D5\u05D5\u05D8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D7\u05E6\u05D9\u05DD") : item.name,
            ref: index === 0 ? bgRef : null,
            type: "radio",
            name: id,
            value: item.value,
            tabIndex: !noFocus ? -1 : undefined,
            id: radioId,
            checked: item.value === selectedButton // disabled={!color.details.inStock}
            ,
            onChange: function onChange() {
              handleChange(item.value, index);
              setSelectedButton(item.value);
            }
          }), customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
            $isBattery: isBattery,
            htmlFor: radioId,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
              children: [item.secondaryName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                children: [item.secondaryName.toUpperCase(), "\xA0"]
              }), (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toUpperCase()]
            })
          })]
        }, item.value);
      })
    }) // </RowWithTitle>

  );
});
SingleButtonSelection.displayName = "SingleButtonSelection";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(SingleButtonSelection));

/***/ }),

/***/ 4162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ choose_picture; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./components/Reusable/Bit/SingleButtonSelection.tsx
var SingleButtonSelection = __webpack_require__(26490);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
// EXTERNAL MODULE: ./components/CreateAi/CreateAiContext.tsx
var CreateAiContext = __webpack_require__(90374);
// EXTERNAL MODULE: ./components/CreateAi/CreatePictureAiButton.tsx
var CreatePictureAiButton = __webpack_require__(78980);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/CreateAi/ChoosePictureAiPage.tsx


















var StyledDesktopWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "ChoosePictureAiPage__StyledDesktopWrapper",
  componentId: "sc-12xue3e-0"
})(["", "{display:flex;padding-top:120px;justify-content:space-between;align-items:flex-start;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChoosePictureAiPage__StyledContainer",
  componentId: "sc-12xue3e-1"
})(["", "{padding-top:100px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h1",
  variant: "h1"
}).withConfig({
  displayName: "ChoosePictureAiPage__StyledTitle",
  componentId: "sc-12xue3e-2"
})(["color:", ";white-space:nowrap;font-size:40px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;height:40px;display:flex;align-items:center;gap:8px;margin-bottom:8px;"], colors/* default.black */.Z.black);
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChoosePictureAiPage__StyledContent",
  componentId: "sc-12xue3e-3"
})(["margin-bottom:30px;", "{margin-bottom:40px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledExplanation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "ChoosePictureAiPage__StyledExplanation",
  componentId: "sc-12xue3e-4"
})(["font-size:20px;font-weight:100;color:#000;line-height:1.2;text-align:right;"]);
var StyledChoosePictureContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChoosePictureAiPage__StyledChoosePictureContent",
  componentId: "sc-12xue3e-5"
})(["display:flex;align-items:center;margin-top:30px;gap:16px;margin-bottom:16px;", "{margin-bottom:24px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChoosePictureAiPage__StyledImageWrapper",
  componentId: "sc-12xue3e-6"
})(["aspect-ratio:400 / 442;width:100%;position:relative;", "{width:442px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledChoosePicture = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "ChoosePictureAiPage__StyledChoosePicture",
  componentId: "sc-12xue3e-7"
})(["font-size:20px;font-weight:400;font-family:\"NarkisBlock\",sans-serif;color:#000;line-height:1.2;text-align:right;", "{font-size:26px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledInfo = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body2"
}).withConfig({
  displayName: "ChoosePictureAiPage__StyledInfo",
  componentId: "sc-12xue3e-8"
})(["font-size:14px;display:flex;align-items:center;gap:4px;color:", ";", "{font-size:18px;}"], colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledChoosenPicturesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChoosePictureAiPage__StyledChoosenPicturesWrapper",
  componentId: "sc-12xue3e-9"
})(["display:flex;align-items:center;justify-content:flex-start;margin-bottom:30px;", "{margin-bottom:40px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledChoosenPicture = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "ChoosePictureAiPage__StyledChoosenPicture",
  componentId: "sc-12xue3e-10"
})(["opacity:0.5;img{border-radius:8px;}", "{width:120px;height:101px;margin-left:16px;cursor:pointer;&:hover{border:solid 1px ", ";border-radius:8px;padding:2px;opacity:1;}}width:76px;height:64px;position:relative;margin-left:8px;", ""], function (p) {
  return p.theme.breakpoints.up("md");
}, colors/* default.black */.Z.black, function (p) {
  return p.$isSelected && "\nborder:solid 1px ".concat(colors/* default.black */.Z.black, ";\nborder-radius:8px;\npadding:2px;\nopacity:1;\n");
});
var StyledNewPicture = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ChoosePictureAiPage__StyledNewPicture",
  componentId: "sc-12xue3e-11"
})(["border-radius:8px;border:dashed 1px ", ";display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;width:76px;height:64px;", "{width:120px;height:101px;cursor:pointer;}"], colors/* default.darkGrey */.Z.darkGrey, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledNewPictureText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "ChoosePictureAiPage__StyledNewPictureText",
  componentId: "sc-12xue3e-12"
})(["font-size:14px;font-weight:100;color:#000;line-height:1.2;text-align:right;", "{font-size:18px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var ChoosePictureAiPage = function ChoosePictureAiPage() {
  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      responseImageUrl = _useCreateAiContext.responseImageUrl,
      sessionId = _useCreateAiContext.sessionId,
      setResponseImageUrl = _useCreateAiContext.setResponseImageUrl,
      limitAiImages = _useCreateAiContext.limitAiImages;

  var _useState = (0,react.useState)(),
      responseImages = _useState[0],
      setResponseImages = _useState[1];

  (0,react.useEffect)(function () {
    var getHistoryImages = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api.postAiImageAiImageHistory)({
                  sessionId: sessionId
                });

              case 2:
                res = _context.sent;
                setResponseImages(res.data.body);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getHistoryImages() {
        return _ref.apply(this, arguments);
      };
    }();

    getHistoryImages();
  }, []);
  var router = (0,next_router.useRouter)();

  var renderImage = function renderImage(radioId, isSelected, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledChoosenPicture, {
        htmlFor: radioId,
        $isSelected: isSelected,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectFit: "cover",
          objectPosition: "top",
          src: responseImages[index].url,
          alt: "",
          width: isSelected ? 114 : 120,
          height: isSelected ? 95 : 101
        })
      })
    });
  };

  var setPictures = function setPictures(code) {
    var selectedImage = responseImages === null || responseImages === void 0 ? void 0 : responseImages.find(function (b) {
      return b.url === code;
    });
    setResponseImageUrl(selectedImage.url);
  };

  var submitAiCard = function submitAiCard() {
    var _responseImages$find, _responseImages$find2, _responseImages$find3;

    if (!responseImageUrl) {
      return;
    }

    localStorage.setItem("imageAiGuid", JSON.stringify(responseImages === null || responseImages === void 0 ? void 0 : (_responseImages$find = responseImages.find(function (b) {
      return b.url === responseImageUrl;
    })) === null || _responseImages$find === void 0 ? void 0 : _responseImages$find.imageGuid));
    localStorage.setItem("imageAiUrl", JSON.stringify(responseImages === null || responseImages === void 0 ? void 0 : (_responseImages$find2 = responseImages.find(function (b) {
      return b.url === responseImageUrl;
    })) === null || _responseImages$find2 === void 0 ? void 0 : _responseImages$find2.url));
    localStorage.setItem("slugAi", JSON.stringify(responseImages === null || responseImages === void 0 ? void 0 : (_responseImages$find3 = responseImages.find(function (b) {
      return b.url === responseImageUrl;
    })) === null || _responseImages$find3 === void 0 ? void 0 : _responseImages$find3.blessingSlug));
    router.push("/giftcard/".concat(JSON.parse(localStorage.getItem("slugAi"))));
  };

  var renderResponsesImages = function renderResponsesImages() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledChoosePictureContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledChoosePicture, {
          children: "\u05D0\u05D9\u05D6\u05D5 \u05EA\u05DE\u05D5\u05E0\u05D4 \u05D0\u05D4\u05D1\u05EA?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledInfo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/img/icons/infoIcon.svg",
            width: 20,
            height: 20,
            alt: "info-icon"
          }), "\u05E0\u05D9\u05EA\u05DF \u05DC\u05D9\u05D9\u05E6\u05E8 \u05E2\u05D3 4 \u05EA\u05DE\u05D5\u05E0\u05D5\u05EA", " "]
        })]
      }), (responseImages === null || responseImages === void 0 ? void 0 : responseImages.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledChoosenPicturesWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SingleButtonSelection/* default */.Z, {
          id: "amount",
          items: responseImages === null || responseImages === void 0 ? void 0 : responseImages.map(function (background) {
            return {
              value: background.url,
              name: background.imageGuid
            };
          }),
          onSelect: function onSelect(code) {
            return setPictures(code);
          },
          gap: 15,
          itemsPerRow: "auto",
          selectedValue: responseImageUrl,
          customButton: function customButton(radioId, isSelected, item, index) {
            return renderImage(radioId, isSelected, index);
          }
        }), (responseImages === null || responseImages === void 0 ? void 0 : responseImages.length) < limitAiImages && (responseImages === null || responseImages === void 0 ? void 0 : responseImages.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledNewPicture, {
          onClick: function onClick() {
            return router.push("/create-ai");
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: 33,
            height: 33,
            src: "/img/aiIcon.svg"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledNewPictureText, {
            children: "\u05EA\u05DE\u05D5\u05E0\u05D4 \u05D7\u05D3\u05E9\u05D4"
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledDesktopWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          children: "\u05E0\u05D5, \u05D0\u05D9\u05DA \u05D9\u05E6\u05D0?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExplanation, {
          children: "\u05D6\u05D5 \u05D4\u05EA\u05DE\u05D5\u05E0\u05D4 \u05E9\u05D4-AI \u05D9\u05E6\u05E8 \u05DC\u05DA"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MediaQueries/* Desktop */.Hi, {
        children: [renderResponsesImages(), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericButton/* default */.Z, {
          onClick: submitAiCard,
          btnType: "filled",
          children: "\u05E1\u05D9\u05D9\u05DE\u05EA\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8, \u05D4\u05DC\u05D0\u05D4"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: responseImageUrl,
            layout: "fill",
            alt: "ai-icon"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
        children: renderResponsesImages()
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: responseImageUrl,
          layout: "fill",
          alt: "ai-icon"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CreatePictureAiButton/* default */.Z, {
        enabledButton: true,
        text: "סיימתי לבחור, הלאה",
        submit: submitAiCard
      })
    })]
  });
};

/* harmony default export */ var CreateAi_ChoosePictureAiPage = (ChoosePictureAiPage);
;// CONCATENATED MODULE: ./src/pages/create-ai/choose-picture/index.tsx






var ChoosePicture = function ChoosePicture() {
  var seo = {
    title: "יצירת תמונה ב-AI|איך יצא?",
    description: "חדש! יצירת תמונה של מקדונלד׳ס בהתאמה אישית",
    keywords: "יצירת תמונה ב-AI"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_ChoosePictureAiPage, {})]
  });
};

/* harmony default export */ var choose_picture = (ChoosePicture);

/***/ }),

/***/ 89834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-ai/choose-picture",
      function () {
        return __webpack_require__(4162);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3450,9774,2888,179], function() { return __webpack_exec__(89834); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);